import { render, staticRenderFns } from "./ElementVideo.vue?vue&type=template&id=5f2a739e&"
import script from "./ElementVideo.vue?vue&type=script&lang=ts&"
export * from "./ElementVideo.vue?vue&type=script&lang=ts&"
import style0 from "./ElementVideo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports